import { createStore } from 'vuex';

import game from './modules/game';

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
  modules: {
    game,
  },
  strict: debug,
});
